import React from "react";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import ShowcaseStrip from "../components/site/ShowcaseStrip";
import About from "../components/site/About";
import ServiceRequestForm from "../components/site/ServiceRequestForm";
import Footer from "../components/site/Footer";
import { Phone, Mail, Clock, MapPin } from "lucide-react";

const COMPRESSOR_IMG =
  "https://images.unsplash.com/photo-1738918922725-d70c666ddccb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwYWlyJTIwY29tcHJlc3NvciUyMGZhY3RvcnklMjBtYWNoaW5lcnl8ZW58MHx8fHwxNzc4MTI1MTQxfDA&ixlib=rb-4.1.0&q=85";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <Services />
        <ShowcaseStrip />
        <About />

        {/* Request + sidebar */}
        <section
          id="request"
          data-testid="request-section"
          className="relative overflow-hidden py-20 md:py-32 px-6 md:px-12 border-y border-slate-900 bg-slate-950"
        >
          <div
            className="absolute inset-0 bg-cover bg-center opacity-90"
            style={{ backgroundImage: "url('https://images.unsplash.com/photo-1524514587686-e2909d726e9b?auto=format&fit=crop&w=2400&q=85')" }}
            aria-hidden
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-slate-950/85 to-slate-950/55" aria-hidden />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/40 via-transparent to-slate-950" aria-hidden />
          <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-7">
              <ServiceRequestForm />
            </div>

            <aside className="lg:col-span-5 lg:pl-6 self-start">
              <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-blue-400">
                Why book with Pneupro
              </div>
              <h2 className="font-heading mt-3 text-4xl md:text-5xl font-black tracking-tighter uppercase text-white">
                Service that respects your downtime.
              </h2>
              <p className="mt-5 text-slate-300 leading-relaxed">
                Submit a request and a dispatch coordinator routes it to the closest qualified
                technician across British Columbia. Most non-emergency jobs are scheduled within 24
                hours, and after-hours service is available on request.
              </p>

              <div className="mt-8 overflow-hidden border border-blue-900/60">
                <img src={COMPRESSOR_IMG} alt="Industrial air compressors" className="w-full h-56 object-cover" />
              </div>

              <div id="contact" data-testid="contact-section" className="mt-8 grid grid-cols-1 gap-3 scroll-mt-24">
                <div className="border border-blue-900/60 bg-blue-950/40 backdrop-blur-sm p-5 flex items-center gap-4">
                  <Phone className="h-5 w-5 text-blue-400" />
                  <div className="flex-1">
                    <div className="text-[11px] font-bold uppercase tracking-widest text-blue-300/80">
                      Phone
                    </div>
                    <a data-testid="request-aside-phone-primary" href="tel:+17788680678" className="font-heading font-bold text-white hover:text-blue-300 block">
                      (778) 868-0678
                    </a>
                    <a data-testid="request-aside-phone-secondary" href="tel:+16044172754" className="font-heading font-bold text-white hover:text-blue-300 block">
                      (604) 417-2754
                    </a>
                  </div>
                </div>
                <div className="border border-blue-900/60 bg-blue-950/40 backdrop-blur-sm p-5 flex items-center gap-4">
                  <Mail className="h-5 w-5 text-blue-400" />
                  <div className="flex-1">
                    <div className="text-[11px] font-bold uppercase tracking-widest text-blue-300/80">
                      Service Email
                    </div>
                    <a data-testid="request-aside-email" href="mailto:pneuprocomp@gmail.com" className="font-heading font-bold text-white hover:text-blue-300 break-all">
                      pneuprocomp@gmail.com
                    </a>
                  </div>
                </div>
                <div className="border border-blue-900/60 bg-blue-950/40 backdrop-blur-sm p-5 flex items-center gap-4">
                  <Clock className="h-5 w-5 text-blue-400" />
                  <div className="flex-1">
                    <div className="text-[11px] font-bold uppercase tracking-widest text-blue-300/80">
                      Office Hours
                    </div>
                    <div className="font-heading font-bold text-white">Mon–Fri · 7:00 – 15:00</div>
                    <div className="text-xs text-slate-400 mt-0.5">After-hours service available</div>
                  </div>
                </div>
                <div className="border border-blue-900/60 bg-blue-950/40 backdrop-blur-sm p-5 flex items-center gap-4">
                  <MapPin className="h-5 w-5 text-blue-400" />
                  <div className="flex-1">
                    <div className="text-[11px] font-bold uppercase tracking-widest text-blue-300/80">
                      Based In
                    </div>
                    <div className="font-heading font-bold text-white">Surrey, British Columbia</div>
                    <div className="text-xs text-slate-400 mt-0.5">Serving all of BC</div>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
